module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alex Sanchez\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Alex Sanchez")]), _vm._v(" spent almost fifteen years working with youth. He is the author of the teen novels "), _c('I', [_vm._v("Boyfriends with Girlfriends")]), _vm._v(", "), _c('I', [_vm._v("Bait")]), _vm._v(", "), _c('I', [_vm._v("The God Box")]), _vm._v(", "), _c('I', [_vm._v("Getting It")]), _vm._v(", "), _c('I', [_vm._v("Rainbow Boys")]), _vm._v(", "), _c('I', [_vm._v("Rainbow High")]), _vm._v(", and "), _c('I', [_vm._v("Rainbow Road")]), _vm._v(", as well as the Lambda Award–winning middle-grade novel "), _c('I', [_vm._v("So Hard to Say")]), _vm._v(". Lambda Literary Foundation honored Alex with an Outstanding Mid-Career Novelists’ Prize. He lives in Thailand and Hollywood, Florida. Visit him at AlexSanchez.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VUW1JV/tc-custom/9781416995050.jpg?1730493398082",
      "alt": "This image is the cover for the book Bait"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bait\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("After Diego lands himself on probation for fighting, he doesn’t trust his probation officer, Mr. Vidas. But as he begins to open up, Diego realizes that he needs Mr. Vidas’s help to get his anger under control. To do that, Diego will need to face the nightmares from his past head-on and confront the memories he’s been avoiding. Will anyone even believe him if he tells the truth about his stepfather? Award-winning author Alex Sanchez writes about a teen’s very real struggle to overcome his anger and take control of his life.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    S&S Books for Young Readers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0